import Icon from "@ui-kit/icons/Icon.web";
import { CardBrandLogoProps } from "./CardBrandLogo.props";

function CardBrandLogo({ brand }: CardBrandLogoProps) {
  if (brand === "amex") return <Icon.AmexLogo />;
  if (brand === "visa") return <Icon.VisaLogo />;
  if (brand === "mastercard") return <Icon.MastercardLogo />;
  if (brand === "discover") return <Icon.DiscoverLogo />;
  if (brand === "diners") return <Icon.DinersLogo />;
  if (brand === "jcb") return <Icon.JCBLogo />;
  if (brand === "unionpay") return <Icon.UnionPayLogo />;

  return null;
}

export default CardBrandLogo;
